export default {"src":"/_next/static/media/BigBlueButton.502b6556.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};